export const columns = [
    {
        title: 'Tên dự án',
        key: 'name',
        dataIndex: 'name',
        width: 400,
    },
    {
        title: 'Ghi chú',
        key: 'note',
        dataIndex: 'note',
    },

];
